import React from 'react';
import { CampdeskLogo } from '@/components/svg/CampdeskLogo.tsx';

const AppLoader = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-basic-white">
      <CampdeskLogo />
      <div className="mt-8">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-[#F7CE6E] border-t-transparent"></div>
      </div>
    </div>
  );
};

export default AppLoader;
